module.exports = __webpack_public_path__ + "static/media/icon_payment_canceled.08d90b8b.svg";